import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import useAuth from "../hooks/useAuth";
import { getLanguage } from "../utils/getLanguage";

const ZendeskWidget = () => {
  const lang = getLanguage();
  const user = useAuth();

  useEffect(() => {
    if (user.id) return;

    const initZendesk = () => {
      if (!window.zE) return;

      window.zE("webWidget", "setLocale", lang === "ar" ? "ar" : "en");

      window.zE("webWidget", "updateSettings", {
        webWidget: {
          color: {
            theme: "#000",
          },
          position: {
            horizontal: lang === "ar" ? "left" : "right",
            vertical: "bottom",
          },
          launcher: {
            label: {
              "*": lang === "ar" ? "مساعدة" : "Help",
            },
          },
        },
      });

      window.zE("webWidget", "show");
    };

    if (!window.zE) {
      const script = document.createElement("script");
      script.id = "ze-snippet";
      script.src = "https://static.zdassets.com/ekr/snippet.js?key=588e37d8-d76c-4f1b-a935-0536b8669f77";
      script.async = true;
      script.onload = initZendesk;
      document.body.appendChild(script);
    } else {
      initZendesk();
    }

    return () => {
      if (window.zE) {
        window.zE("webWidget", "hide");
      }
    };
  }, [lang, user.id]); // ✅ Dependencies are correct

  return null;
};

export default ZendeskWidget;
